export const SET_ACTIVE_TAB = 'tabs:set-active-tab'
